import {React, useEffect, useState, useRef}  from 'react';
import ExpandedImage from './ExpandedImage.js';
import '../App.css';
import './mats.css';
import SlideInDiv from './slider.js'
import SlideInDivLeft from './slider2.js'
import { GiWillowTree } from "react-icons/gi";

const Mats = () => {
    const [isVisibleImage9, setIsVisibleImage9] = useState(false);
    const imageRef9 = useRef(null);
    const [expandedImage9, setExpandedImage9] = useState(null);

    const handleScroll9 = () => {
                
                  if (imageRef9.current) {
                    const imageRect9 = imageRef9.current.getBoundingClientRect();
                    const triggerOffsetImage9 = 130; // Adjust this value for different trigger points
                    const triggerPointImage9 = window.innerHeight - triggerOffsetImage9;
                    const isAboveTriggerPointImage9 = imageRect9.top < triggerPointImage9;
                    setIsVisibleImage9(isAboveTriggerPointImage9);
                  }
    
            };
          
            useEffect(() => {
                window.addEventListener('scroll', handleScroll9);
                handleScroll9(); // Check visibility on initial render
                return () => {
                  window.removeEventListener('scroll', handleScroll9);
                };
            }, []);
    
                
                useEffect(() => {
                      const hash = window.location.hash.substring(1);
                      if (hash) {
                        const targetElement = document.getElementById(hash);
                        if (targetElement) {
                            targetElement.scrollIntoView({ behavior: 'smooth' });
                        }
                      }
                  }, []);
    

    

    return (
        <div id="moduletwo_half">
            		<div id='slideCon_matts'>
							<SlideInDiv>
								<div id='slideInDive_matts1'></div>	
							</SlideInDiv>
								<div id='container_Slide_matts'>
							<SlideInDivLeft>
								<div id='slideInDive_matts2'></div>
							</SlideInDivLeft>
							<SlideInDivLeft>
								<div id='slideInDive_matts3'></div>
							</SlideInDivLeft>
                            </div>
                            
					</div>
                    <div id="moduletwo_half_div1">
                        <div id='icon_two_half0_3matts'>
                        <div id='two_half_text0_1_3matts'><h1> - - - - - -&nbsp;&nbsp;</h1>
                        </div><div id='icon_two_half_icon0_3matts'><GiWillowTree /></div>
                        <div id='two_half_text0_2_3matts'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
                        </div>
                        <div id="moduletwo_half_div2">
                            <h1>Premium Ground Protection — Included on Every Job</h1>
                            <h2>“Most tree companies don't use them. We wouldn't step foot on your lawn without them.”</h2>
							<p>At <strong>Sam's Tree Service</strong>, we don't just remove and trim trees — we protect 
                                what's around them. For large trees in tight spaces, we use careful techniques to get the 
                                job done without damaging your yard. A common request from 
                                homeowners is to not damage their lawns. Our solution is <strong>Ground Protection Mats </strong> 
                                Instead of driving heavy equipment directly over the lawn, we use heavy-duty 
                                ground protection mats. These mats distribute weight evenly to prevent ruts, 
                                protect irrigation systems, and preserve turf and landscaping.
                                The result is simple: no damage, no mess, no regrets.</p>
                                <ul>
                                    <li>Heavy-duty mats safeguard your grass, irrigation, and hardscaping</li>
                                    <li>No gouges, ruts, or cleanup nightmares</li>
                                    <li>The same protection used on golf courses, estates, and luxury properties</li>
                                </ul>
                        </div>
                        
                    </div>	
                        
                
                        
        
        </div>
    );
};

export default Mats;

/*<div id='modulesix_pic9'>
                        <div id='modulesix_text9'>
                            <div id='icon_six29'>
                                <div id='six_text2_19'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
                                <div id='icon_six_icon29'><GiFruitTree /></div>
                                <div id='six_text2_29'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
                            </div>				
                            <h1>Explore Our Tree Service Expertise</h1>
                        </div>
                        <div id="collect-grid-container9" ref={imageRef9}>
                            {images.map((image) => (
                        
                        <div className={`collect-grid-item9 ${isVisibleImage9  ? 'visible' : ''}`} key={image.id}  style={{ transitionDelay: '.3s' }} onClick={() => handleGridItemClick9(image)}>
                            <img src={image.url} alt={image.alt} />
                        </div>
                    ))}
                        
                    </div>
                    <div className="modal-overlay2"></div>
                    <div className="modal-container2">
                        {expandedImage9 && (
                            <ExpandedImage imageUrl={expandedImage9.url} relatedImages={expandedImage9.relatedImages} onClose={handleCloseExpandedImage9} />
                        )}
                    </div>
                            
                        </div>
                        
*/